<template>

  <div class="col-lg-10 col-lg-offset-1">
    <div class="hpanel">
      <div class="panel-heading">
        Incomplete Gate Tickets
      </div>
      <div class="panel-body">
        <div class="table-responsive">
          <vue-good-table
            :columns="columns"
            :rows="gatePasses"
            :paginate="true"
            :globalSearch="true"
            :lineNumbers="true"
            styleClass="table table-responsive table-bordered table-stripped"
            :loading="$loadingTrue"
          >
            <template slot="table-row" slot-scope="props">
              <td class="fancy">{{ props.row.gatepass_ref_code}}</td>
              <td class="fancy">{{ props.row.destination}}</td>
              <td class="fancy">{{ formated_date(props.row.booking_check_in_date)}}</td>
              <td class="fancy">{{ formated_date(props.row.booking_check_out_date)}}</td>
              <td class="fancy">{{ props.row.guest_total}}</td>
              <td class="fancy">{{ props.row.gatepass_payment_status}}</td>
              <td class="fancy">{{ props.row.gatepass_done_by}}</td>
              <td class="fancy">
                <button v-if="props.row.gatepass_payment_status === 'Not Paid'" class="btn btn-info btn-sm" @click="payForGatepass(props.row.gatepass_public_id)">Pay</button>
                <button v-if="props.row.gatepass_payment_status === 'Paid'" class="btn btn-info btn-sm" disabled>Pay</button>
              </td>
            </template>
          </vue-good-table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      columns: [
        {
          label: 'Ref',
          value: 'gatepass_ref_code'
        },
        {
          label: 'Destination',
          value: 'destination'
        },
        {
          label: 'Check In',
          value: 'check_in'
        },
        {
          label: 'Check Out',
          value: 'check_out'
        },
        {
          label: 'Number of Guests',
          value: 'guest_total'
        },
        {
          label: 'Payment Status',
          value: 'gatepass_payment_status'
        },
        {
          label: 'Done By',
          value: 'gatepass_done_by'
        },
        {
          label: 'Action',
          value: ''
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('get_passes')
  },
  methods: {
    payForGatepass: function (publicId) {
      this.$router.push({
        value: 'GatePayment',
        params: {
          gate_id: publicId
        }
      })
    }
  }
}
</script>

<style>

</style>
